import {post, get} from '@/utils/request'

/**
 * 获取验证图片以及位置
 */
export function getCaptchaImageReqAPI(data) {
	return get({
		data,
		url: 'gateway/captcha/slide'
	})
}

/**
 * 获取验证图片以及位置
 */
export function loginAPI(data) {
	return post({
		data,
		url: 'gateway/member/login',
		headers: {'Content-Type': 'application/x-www-form-urlencoded'}
	})
}

/**
 * 查询验证图片是否通过
 */
export function checkCaptchaReq(data) {
	return post({
		data,
		url: '!ESale/Mall/UI/~java/SlideCaptcha.checkCaptcha'
	})
}

// 登陆
export function oldLogin(data) {
	return post({
		data,
		// url: '!sys/security/~java/Login'
		url: '!Manage/User/~java/Login.doLogin'
	})
}